export default "__VITE_ASSET__BcNd5z1K__"